import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'unavailable-hint',
  templateUrl: './unavailable-hint.component.html',
  styleUrls: ['./unavailable-hint.component.scss']
})
export class UnavailableHintComponent implements OnInit {

  @HostBinding('style.right')
  @Input() right: string = '0px';
  @HostBinding('style.top')
  @Input() top: string = '0px';

  public pickerId: string = '';

  ngOnInit() {
    // Use a timestamp + component instance hash for more stable ID
    this.pickerId = `popup-${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
  }
}
